import { render, staticRenderFns } from "./FPhone.vue?vue&type=template&id=367430e4"
import script from "./FPhone.vue?vue&type=script&lang=js"
export * from "./FPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports